import classNames from 'classnames';
import {Typography} from 'components/Typography';
import React, {FC, useCallback, useState} from 'react';
import style from './style.module.scss';
import {CatalogMenuSectionCategories} from 'modules/categories/components/CatalogMenuSectionCategories';
import {ICategorySection} from 'modules/categories/types';
import Icon from 'components/Icon';
import Link from 'components/CustomRoutingLink';

interface IProps {
    categoriesList: ICategorySection[];
    depth: number;
}

export const CatalogMenuSection: FC<IProps> = ({categoriesList, depth}) => {
    const [activeCategoryId, setActiveCategoryId] = useState<ICategorySection['id'] | null>(1);

    const switchCategory = useCallback((categoryId: ICategorySection['id']) => {
        setActiveCategoryId(categoryId);
    }, []);

    const renderSectionView = (categoryNode: ICategorySection) => {
        const isDiscount = 'discount' === categoryNode.code;
        const isActive = categoryNode.id === activeCategoryId;

        if (categoryNode.categories?.length) {
            return (
                <li
                    className={classNames(style.catalogMenuSectionItem, style.catalogMenuSectionItemGrayTheme, {
                        [style.catalogMenuSectionItemActive]: isActive,
                    })}
                    key={categoryNode.id}
                    onMouseEnter={() => switchCategory(categoryNode.id)}
                >
                    <Link className={style.catalogMenuSectionItemName} href={categoryNode.sectionLink || ''}>
                        <div className={classNames(style.catalogMenuCategoryText)}>
                            <Typography color={'gray100'} element={'span'} variant={'h5'}>
                                {categoryNode.name}
                                {categoryNode.isMarked && <span className={classNames('mark', style.mark)} />}
                            </Typography>
                        </div>
                        <div
                            className={classNames(style.chevron, {
                                [style.chevronVisible]: isActive,
                            })}
                        >
                            <Icon icon={'down'} />
                        </div>
                    </Link>
                </li>
            );
        }
        return (
            <li
                className={classNames(style.catalogMenuSectionItem, style.catalogMenuBlackTheme, {
                    [style.catalogMenuDiscountTheme]: isDiscount,
                })}
                key={categoryNode.id}
            >
                <Link href={categoryNode.link || ''}>
                    <div className={style.catalogMenuSectionItemName}>
                        <Typography
                            className={classNames(style.catalogMenuCategoryText, {
                                [style.catalogMenuCategoryTextDiscount]: isDiscount,
                            })}
                            element={'span'}
                            variant={'h5'}
                        >
                            {categoryNode.name}
                        </Typography>
                    </div>
                </Link>
            </li>
        );
    };

    return (
        <>
            <div className={style.root} style={{zIndex: depth}}>
                <ul className={classNames(style.catalogMenuSection)}>
                    {categoriesList.map((categoryNode) => renderSectionView(categoryNode))}
                </ul>
            </div>
            {categoriesList.map(
                (category) =>
                    category &&
                    category.categories &&
                    Boolean(category?.categories?.length) && (
                        <div
                            className={classNames(
                                style.categoriesContainer,
                                category.id === activeCategoryId ? style.active : undefined,
                            )}
                            key={category.id}
                        >
                            <CatalogMenuSectionCategories
                                activeCode={category.code}
                                banners={category.banners}
                                categories={category.categories}
                                presentLink={category.presentLink}
                                section={category.nameAll}
                                sectionLink={category.sectionLink}
                            />
                        </div>
                    ),
            )}
        </>
    );
};
